module.exports = "/_next/static/images/key-4b1346ef90c467c214ce3a2fc4b82389.svg";